import { combineReducers } from "@reduxjs/toolkit";
import state from "./stateSlice";
import data from "./dataSlice";

const bomFormReducer = combineReducers({
  state,
  data,
});

export default bomFormReducer;
